import RMModal from 'components/modal/RMModal';
import React, { useState } from 'react';

const useAwaitableModal = () => {
  const [showModal, setShowModal] = useState(false);
  const [promiseInfo, setPromiseInfo] = useState({
    resolve: null,
    reject: null,
  });
  const [heading, setHeading] = useState('');
  const [body, setBody] = useState<any>();

  const shouldShowModal = async (heading, body): Promise<boolean> =>
    new Promise<boolean>((resolve, reject) => {
      setPromiseInfo({ ...promiseInfo, resolve: resolve, reject: reject });
      setHeading(heading);
      setBody(body);
      setShowModal(true);
    });

  const hide = () => {
    setShowModal(false);
  };

  const renderModal = (): React.ReactElement => (
    <RMModal
      id="useawaitablemodal-rendermodal"
      showModal={showModal}
      setShowModal={setShowModal}
      heading={heading}
      body={body}
      onOk={() => {
        hide();
        promiseInfo?.resolve(true);
      }}
      onCancel={() => {
        hide();
        promiseInfo?.resolve(false);
      }}
      onHide={() => {
        hide();
        promiseInfo?.resolve(false);
      }}
      noButtonText="No"
    />
  );

  return { showModal: shouldShowModal, modalContent: renderModal() };
};

export { useAwaitableModal };
